<template>
  <div>
    <btn slot="Button" @click="handleButtonClick" v-if="isVisible">{{
      rowButtonText
    }}</btn>
    <div v-if="isRolloverVisible" class="tdRolloverLink">
      <a href="#" @click.prevent="handleRolloverClick">Rollover</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tdButton',
  props: ['row', 'xprops'],
  computed: {
    rowButtonText() {
      return this.xprops.getRowButtonText(this.row);
    },
    isVisible() {
      return this.xprops.getRowButtonVisible(this.row);
    },
    isRolloverVisible() {
      if (typeof this.xprops.getRowRolloverButtonVisible !== 'function') {
        return false;
      }
      return this.xprops.getRowRolloverButtonVisible(this.row);
    },
  },
  methods: {
    handleButtonClick() {
      this.xprops.eventbus.$emit('TD_BUTTON_CLICK', this.row);
    },
    handleRolloverClick() {
      this.xprops.eventbus.$emit('TD_ROLLOVER_BUTTON_CLICK', this.row);
    },
  },
};
</script>

<style scoped>
.tdRolloverLink {
  margin-top: 4px;
  text-align: center;
  font-size: 0.9em;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderTable/components/tdButton.vue